import React from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';
import { SendWhatsAppMessage } from '../../../../api/WhatsappAPI';
import MessagesTemplate from '../../../../consts/MessagesTemplate';
import CalendarConfig from '../../../../consts/CalendarConfig';
import { PrepareManualNPSMessageAPI } from '../../../../api/API';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import usePlanLock from '../../../../hooks/usePlanLock';
import { SUBSCRIPTION_PERMISSIONS } from '../../../../consts/SubscriptionFeatures';
import PatientItem from '../shared/PatientItem';
import { ContactActions } from '../shared/IconAction';
import useSentFlag from '../../hooks/useSentFlag';
import RelationshipSection from './RelationshipSection';
import { procedureLabels } from '../../../appointments/v2/utils/appointmentUtils';

function NPSFeedbackItem({ item, onBlockedAction }) {
  const { CompanyConfig, GetPatientById, GetResourceById } = DataProviderInstance();
  const templates = MessagesTemplate.getTemplates(CompanyConfig);
  const [sent, markSent] = useSentFlag(`npsMsgSent-v2-${item.id}`);

  // item.patient, .resource e .procedure são IDs — resolver via DataProvider
  const patient = GetPatientById(item.patient);
  const resourceName = GetResourceById(item.resource)?.Label || '';
  const procedureName = procedureLabels(item, CompanyConfig?.Procedures);
  const patientName = patient?.name || 'Paciente';
  const patientPhone = patient?.phone || '';
  const hasPhone = patientPhone.length >= 8;
  const appointmentDate = item.date ? CalendarConfig.GetDDMMAAAA(item.date).slice(0, 5) : '';

  function handleWhatsApp() {
    if (onBlockedAction) {
      onBlockedAction();
      return;
    }
    let message = templates.NPSFeedbackRequest || '';
    if (!message) return;

    message = message.replaceAll('{name}', patientName.split(' ')[0]);
    message = message.replaceAll('{company_name}', CompanyConfig?.Name || '');
    message = message.replaceAll('{procedure}', procedureName);
    message = message.replaceAll('{doctor_name}', resourceName);

    SendWhatsAppMessage(patientPhone, MessagesTemplate.ConvertToWhatsAppText(message), patient?.countryCode);

    // Registra o envio manual
    if (item.id) PrepareManualNPSMessageAPI(item.id, () => {});
    markSent();
  }

  return (
    <PatientItem
      name={patientName}
      patientId={item.patient}
      tone="blue"
      sent={sent}
      meta={[appointmentDate && `Consulta em ${appointmentDate}`, procedureName].filter(Boolean).join(' · ')}
      actions={hasPhone && <ContactActions whatsappTitle="Enviar pesquisa de satisfação" onWhatsApp={handleWhatsApp} phone={patientPhone} />}
    />
  );
}

function NPSFeedbackSection({ list }) {
  // Sem relacionamento pela Gabriela e sem número próprio (Essencial), a seção
  // continua visível e o envio abre o modal de planos.
  const lock = usePlanLock(
    [SUBSCRIPTION_PERMISSIONS.PLATFORM_ENGAGEMENT, SUBSCRIPTION_PERMISSIONS.ZAPI_INTEGRATION],
    'A pesquisa de satisfação'
  );

  return (
    <RelationshipSection
      icon={<StarOutlineRoundedIcon style={{ fontSize: 17 }} />}
      tone="blue"
      title="Pesquisa de satisfação"
      hint="Pergunte como foi a consulta"
      count={list.length}
      lock={lock}
    >
      {list.map((item, index) => (
        <NPSFeedbackItem key={item.id || index} item={item} onBlockedAction={lock.locked ? lock.openUpgrade : null} />
      ))}
    </RelationshipSection>
  );
}

export default NPSFeedbackSection;
